import { localStorageHelper, sessionStorageHelper } from '@klarna-web-sdk/utils'

const SHOPPING_STORAGE_KEY = 'klarna-shopping-session'

export const sessionBrowserStorage = sessionStorageHelper(SHOPPING_STORAGE_KEY)
export const localBrowserStorage = localStorageHelper(SHOPPING_STORAGE_KEY)
